<hx-form-group
  [error]="_hasError()"
  [style.display]="'flex'"
  [style.flex-direction]="labelHorizontally() && orientation() === 'horizontal' ? 'row' : 'column'"
  [style.align-items]="labelHorizontally() && orientation() === 'horizontal' ? 'flex-start' : 'stretch'"
  [style.gap]="labelHorizontally() && orientation() === 'horizontal' ? 'var(--spacing-4, 16px)' : '0'">
  <!-- Question Label Container (for labelHorizontally) -->
  @if (labelHorizontally() && orientation() === 'horizontal' && question()) {
    <div class="label-column">
      <hx-label
        class="hx-radio-with-other__question"
        [description]="question()"
        [subtitle]="sublabel()"
        [fontWeight]="labelFontWeight()"
        [fontSize]="labelFontSize()"
        [subtitleFontWeight]="subtitleFontWeight()"
        [subtitleFontSize]="subtitleFontSize()"
        [color]="labelColor()"
        [required]="required()"
        [subtitleColor]="subtitleColor()"
        [tooltip]="tooltip()"
        [tooltipPosition]="tooltipPosition()"
        [tooltipColor]="tooltipColor()"></hx-label>
    </div>
  }

  <div
    class="hx-radio-with-other__group"
    [ngClass]="{ 'radio-column': labelHorizontally() && orientation() === 'horizontal' }">
    <!-- Question and Sublabel (when labelHorizontally is false) -->
    @if (!(labelHorizontally() && orientation() === 'horizontal') && question()) {
      <hx-label
        class="hx-radio-with-other__question"
        [description]="question()"
        [subtitle]="sublabel()"
        [fontWeight]="labelFontWeight()"
        [fontSize]="labelFontSize()"
        [subtitleFontWeight]="subtitleFontWeight()"
        [subtitleFontSize]="subtitleFontSize()"
        [color]="labelColor()"
        [required]="required()"
        [subtitleColor]="subtitleColor()"
        [tooltip]="tooltip()"
        [tooltipPosition]="tooltipPosition()"
        [tooltipColor]="tooltipColor()"></hx-label>
    }

    <!-- Radio Group with all options -->
    <div
      class="hx-radio-with-other__radios"
      [class.hx-radio-with-other__radios--vertical]="orientation() === 'vertical' && !columns()"
      [class.hx-radio-with-other__radios--horizontal]="orientation() === 'horizontal' && !columns()"
      [class.hx-radio-with-other__radios--grid]="!!columns()"
      [class.hx-radio-with-other__radios--justify]="justify() && orientation() === 'horizontal' && !columns()"
      [class.hx-radio-with-other__radios--subcontrol-start]="subControlPosition() === 'start' || !subControlPosition()"
      [style.--hx-radio-columns]="columns()">
      <hx-radio-group
        [(value)]="value"
        [disabled]="disabledState()"
        (valueChange)="_onRadioChange($event)"
        [readonly]="readonly()"
        [required]="required()">
        @for (option of _orderedOptions(); track option) {
          <div class="hx-radio-option-wrapper">
            <hx-radio [value]="option" [readonly]="readonly()">
              {{ option }}
            </hx-radio>
            @if (optionTemplate()) {
              <ng-container *ngTemplateOutlet="optionTemplate()!; context: { $implicit: option }"></ng-container>
            }
          </div>
        }
      </hx-radio-group>
    </div>

    <!-- Conditional "Other" Input Field -->
    @if (_isOtherSelected() && showInputOnOther()) {
      <div class="hx-radio-with-other__input-container" style="margin-top: var(--spacing-3, 12px)">
        @let op = $any(otherInputProps()) ?? {};
        @if (otherControl(); as oc) {
          <hx-input
            [type]="op.type ?? 'text'"
            id="hx-other-input"
            class="hx-radio-with-other__input"
            [label]="reasonLabel()"
            [formControl]="oc"
            [placeholder]="op.placeholder ?? reasonPlaceholder()"
            [subtitle]="op.subtitle ?? ''"
            [hint]="op.hint ?? ''"
            [maxlength]="op.maxlength ?? reasonMaxLength()"
            [minlength]="op.minlength"
            [pattern]="op.pattern"
            [disabled]="disabledState() ?? false"
            [readonly]="readonly() || !!op.readOnly"
            [multiline]="op.multiline ?? otherInputMultiline()"
            [autoExpand]="!!op.autoExpand"
            [rows]="op.rows ?? 3"
            [required]="showInputOnOther()" />
        } @else {
          <hx-input
            [type]="op.type ?? 'text'"
            id="hx-other-input"
            class="hx-radio-with-other__input"
            [label]="reasonLabel()"
            [placeholder]="op.placeholder ?? reasonPlaceholder()"
            [subtitle]="op.subtitle ?? ''"
            [hint]="op.hint ?? ''"
            [maxlength]="op.maxlength ?? reasonMaxLength()"
            [minlength]="op.minlength"
            [pattern]="op.pattern"
            [disabled]="disabledState() ?? false"
            [readonly]="readonly() || !!op.readOnly"
            [multiline]="op.multiline ?? otherInputMultiline()"
            [autoExpand]="!!op.autoExpand"
            [rows]="op.rows ?? 3"
            [required]="showInputOnOther()" />
        }
      </div>
    }
  </div>

  <!-- Error Messages -->
  @if (_hasError()) {
    <span hx-error>
      @if (_internalControl.errors?.['required']) {
        {{ _getErrorMessage('required') }}
      }
    </span>
  }
</hx-form-group>
